import { faEye, faEyeSlash } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IoIosArrowDown } from "react-icons/io";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setEditDriver,
  setEditDriverValue,
  setSearchDriver,
} from "../redux/driver/driver-slice";
import CountryDropdown from "react-select-country-list";
import { Countrycodes } from "../utils/countryCodes";
import CountryList from "country-list-with-dial-code-and-flag";
import { Form } from "react-router-dom";
import { CloudFog } from "lucide-react";

const checkEmail = (inputEmail) => {
  const check = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
    inputEmail,
  );

  return check;
};

const Modal = ({
  heading,
  label,
  cancelOnClick,
  submitOnClick,
  driverNameInput,
  carPlateInput,
  carLicenseInput,
  contactNumberInput,
  countryCodeInput,
  setCountryCodeChange,
  setEditCountryCodeChange,
  driverEmailInput,
  driverPasswordInput,
  isDriverCreate,
  driverPassword,
  driverName,
  driverEmail,
  driverCountryCode,
  driverContactNumber,
  driverCarPlateNumber,
  driverCarLicenseNo,
  isDriverModalEdit,

  tag,
  handleReset,
}) => {
  const { editDriver } = useSelector((state) => state.driver);
  const [searchCountryCode, setsearchCountryCode] = useState("");
  const [selectedCountry1, setSelectedCountry1] = useState(false);
  const [selectedCountry2, setSelectedCountry2] = useState(false);
  const [isVisible, setisVisible] = useState();
  const dispatch = useDispatch();
  const emptyField =
    driverName?.trim() === "" ||
    driverCarPlateNumber?.trim() === "" ||
    driverCarLicenseNo?.trim() === "" ||
    driverEmail?.trim() === "" ||
    driverCountryCode?.trim() === "" ||
    driverContactNumber?.trim() === "" ||
    driverPassword?.trim() === "";

  const [formValidation, setformValidation] = useState({
    driverNameError: "",
    countryCodeError: "",
    contactNumberError: "",
    passwordError: false,
    emailError: "",
  });

  React.useEffect(() => {
    dispatch(
      setEditDriverValue({
        key: "password",
        value: "",
      }),
    );
  }, []);

  let emptyFieldEdit =
    tag == "edit" &&
    !(
      /[a-z]/.test(editDriver.password) &&
      /[A-Z]/.test(editDriver.password) &&
      /[1-9]/.test(editDriver.password) &&
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(editDriver.password)
    );

  React.useEffect(() => {
    handleReset();
    dispatch(
      setEditDriverValue({
        key: "password",
        value: "",
      }),
    );
    dispatch(
      setEditDriverValue({
        key: "contactNumber",
        value: "",
      }),
    );
  }, []);

  return (
    <div className="animate__animated animate__fadeInDown fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
      <div className="relative mx-10 mb-10 mt-16 w-full max-w-3xl lg:w-[37.75rem]">
        {/*content*/}
        <div className="cardBorder1 borderFN">
          <div
            id="grad"
            className="relative flex w-full flex-col rounded-lg shadow-lg outline-none focus:outline-none"
          >
            {/*header*/}
            <div
              className="flex w-full items-start justify-between rounded-t-lg border-b border-solid border-slate-900 bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] px-6 py-3 text-base font-semibold"
              onClick={() => {
                setSelectedCountry2(false);
                setSelectedCountry1(false);
              }}
            >
              <h3 className="text-lg font-medium text-white/90">{heading}</h3>
              <button
                className="float-right ml-auto p-1 text-3xl font-semibold leading-none text-black"
                onClick={cancelOnClick}
              >
                <span className="-mt-3 mr-0 block h-4 w-6 text-4xl text-gray-300">
                  ×
                </span>
              </button>
            </div>
            {/* body */}
            <div>
              {isDriverCreate && (
                <div className="relative z-0 h-[52vh] flex-auto space-y-3 overflow-y-auto p-6 sm:h-auto sm:overflow-y-visible">
                  <div className="space-y-3 sm:flex sm:space-x-5 sm:space-y-0">
                    <div className="grow">
                      <ModalInputField
                        required
                        labelName="Driver Name "
                        type="text"
                        placeholder="Enter User Name"
                        inputvalue={driverName}
                        onChange={(e) => {
                          setformValidation({
                            ...formValidation,
                            driverNameError: "",
                          });
                          driverNameInput(e);
                        }}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                        onBlur={() => {
                          if (driverName === "") {
                            console.log("driver errpr");
                            setformValidation({
                              ...formValidation,
                              driverNameError: "Driver name is required",
                            });
                          } else if (driverName?.trim()?.length < 2) {
                            setformValidation({
                              ...formValidation,
                              driverNameError:
                                "Name should be more than 1 character",
                            });
                          } else {
                            setformValidation({
                              ...formValidation,
                              driverNameError: "",
                            });
                          }
                        }}
                      />

                      <p className="pt-1 text-sm text-red-500">
                        {formValidation.driverNameError !== "" &&
                          formValidation.driverNameError}
                      </p>
                    </div>
                    <div className="grow">
                      <ModalInputField
                        labelName="Car Plate Number"
                        type="text"
                        placeholder="Enter car plate number"
                        inputvalue={driverCarPlateNumber}
                        onChange={carPlateInput}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="space-y-3 sm:flex sm:space-x-5 sm:space-y-0">
                    <div className="grow">
                      <ModalInputField
                        labelName="Car License Number"
                        type="text"
                        placeholder="Enter car license number"
                        inputvalue={driverCarLicenseNo}
                        onChange={carLicenseInput}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                      />
                    </div>
                    <div className="grow">
                      <ModalInputField
                        labelName="Driver Email"
                        type="email"
                        placeholder="Enter driver email"
                        inputvalue={driverEmail}
                        onChange={(e) => {
                          setformValidation({
                            ...formValidation,
                            emailError: "",
                          });
                          driverEmailInput(e);
                        }}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                        onBlur={() => {
                          const check = checkEmail(driverEmail);
                          if (check === false) {
                            setformValidation({
                              ...formValidation,
                              emailError: "Enter valid email",
                            });
                          }
                        }}
                      />
                      <p className="pt-1 text-sm text-red-500">
                        {formValidation.emailError !== "" &&
                          formValidation.emailError}
                      </p>
                    </div>
                  </div>
                  <div className="relative z-20 space-y-3 sm:flex sm:space-x-5 sm:space-y-0">
                    <div className="relative grow">
                      <div>
                        <ModalInputField
                          required
                          labelName="Country Code "
                          type="text"
                          placeholder="Enter country code"
                          inputvalue={driverCountryCode}
                          onChange={(e) => {
                            setSelectedCountry1(true);
                            countryCodeInput(e);
                          }}
                          onBlur={() => {
                            if (driverCountryCode === "") {
                              console.log("driver error");
                              setformValidation({
                                ...formValidation,
                                countryCodeError: "Country is required",
                              });
                            } else {
                              setformValidation({
                                ...formValidation,
                                countryCodeError: "",
                              });
                            }
                          }}
                        />
                        <IoIosArrowDown
                          className="absolute right-3 top-9 h-6 w-6 cursor-pointer text-white"
                          onClick={() => {
                            console.log("CountryList", selectedCountry1);
                            setSelectedCountry1(!selectedCountry1);
                          }}
                        />
                        <p className="pt-1 text-sm text-red-500">
                          {formValidation.countryCodeError !== "" &&
                            formValidation.countryCodeError}
                        </p>
                      </div>
                      <div className="absolute top-[6.6rem] z-40">
                        {selectedCountry1 && (
                          <div className="absolute -left-1 bottom-14 mx-1 h-60 w-[16.7rem] translate-y-64 overflow-y-auto rounded-lg border-2 border-white/30 bg-gradient-to-br from-[#282828] to-black text-white/90 shadow-2xl scrollbar">
                            {Countrycodes?.map((country) => {
                              console.log("single country", country);

                              if (
                                country.name
                                  .toLowerCase()
                                  .includes(driverCountryCode?.toLowerCase())
                              ) {
                                return (
                                  <div
                                    key={country.code}
                                    onClick={() => {
                                      setCountryCodeChange(country);
                                      setSelectedCountry1(false);
                                    }}
                                    className="mx-2 my-2 flex cursor-pointer space-x-3 rounded-md px-3 py-2 text-[15px] hover:bg-white/20 hover:text-white/70"
                                  >
                                    <div>{country.name}</div>
                                    <div>{country.dial_code}</div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="grow">
                      <ModalInputField
                        required
                        labelName="Contact Number"
                        type="text"
                        placeholder="Enter Contact Number"
                        inputvalue={driverContactNumber}
                        onChange={(e) => {
                          setformValidation({
                            ...formValidation,
                            contactNumberError: "",
                          });
                          contactNumberInput(e);
                        }}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                        onBlur={() => {
                          if (driverContactNumber === "") {
                            setformValidation({
                              ...formValidation,
                              contactNumberError: "Driver Contact is required",
                            });
                          } else if (!/^\d+$/.test(driverContactNumber)) {
                            setformValidation({
                              ...formValidation,
                              contactNumberError:
                                "Contact number must be number",
                            });
                          } else if (driverContactNumber?.trim()?.length < 6) {
                            setformValidation({
                              ...formValidation,
                              contactNumberError:
                                "Should be more than 5 character",
                            });
                          } else {
                            setformValidation({
                              ...formValidation,
                              contactNumberError: "",
                            });
                          }
                        }}
                      />
                      <p className="pt-1 text-sm text-red-500">
                        {formValidation.contactNumberError !== "" &&
                          formValidation.contactNumberError}
                      </p>
                    </div>
                  </div>
                  <div className="relative z-10">
                    <div className="space-y-2">
                      <ModalInputField
                        required
                        labelName="Password "
                        type={`${isVisible ? "text" : "password"}`}
                        inputvalue={driverPassword}
                        placeholder="Set password for driver"
                        onChange={(e) => {
                          driverPasswordInput(e);
                        }}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                        onBlur={(e) => {
                          if (!/[a-z]/.test(driverPassword)) {
                            setformValidation({
                              ...formValidation,
                              passwordError: true,
                            });
                          } else if (!/[A-Z]/.test(driverPassword)) {
                            setformValidation({
                              ...formValidation,
                              passwordError: true,
                            });
                          } else if (!/[1-9]/.test(driverPassword)) {
                            setformValidation({
                              ...formValidation,
                              passwordError: true,
                            });
                          } else if (
                            !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                              driverPassword,
                            )
                          ) {
                            setformValidation({
                              ...formValidation,
                              passwordError: true,
                            });
                          } else {
                            setformValidation({
                              ...formValidation,
                              passwordError: false,
                            });
                          }

                          driverPasswordInput(e);
                        }}
                      />
                      {formValidation.passwordError && (
                        <div className={`text-sm text-gray-400`}>
                          <p>
                            Password must be at least 8 characters
                            <span className="text-red-500"> *</span>
                          </p>
                          <div
                            className={`grid grid-cols-1 p-2 sm:grid-cols-2`}
                          >
                            <div className="flex flex-row gap-2">
                              <div className="flex items-center justify-center">
                                {/[a-z]/.test(driverPassword) ? (
                                  <Tick />
                                ) : (
                                  <div className="size-2.5 rounded-full bg-gray-400" />
                                )}
                              </div>
                              One lowercase character
                            </div>
                            <div className="flex flex-row gap-2">
                              <div className="flex items-center justify-center">
                                {/[A-Z]/.test(driverPassword) ? (
                                  <Tick />
                                ) : (
                                  <div className="size-2.5 rounded-full bg-gray-400" />
                                )}
                              </div>
                              One uppercase character
                            </div>
                            <div className="flex flex-row gap-2">
                              <div className="flex items-center justify-center">
                                {/[1-9]/.test(driverPassword) ? (
                                  <Tick />
                                ) : (
                                  <div className="size-2.5 rounded-full bg-gray-400" />
                                )}
                              </div>
                              One digit
                            </div>
                            <div className="flex flex-row gap-2">
                              <div className="flex items-center justify-center">
                                {/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                                  driverPassword,
                                ) ? (
                                  <Tick />
                                ) : (
                                  <div className="size-2.5 rounded-full bg-gray-400" />
                                )}
                              </div>
                              One special symbol
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="absolute right-3 top-9 text-white">
                      <div
                        className="cursor-pointer text-slate-500"
                        onClick={() => {
                          setisVisible(!isVisible);
                        }}
                      >
                        {isVisible ? (
                          <FontAwesomeIcon icon={faEye} />
                        ) : (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div>
              {isDriverModalEdit && (
                <>
                  <div className="relative h-[52vh] flex-auto space-y-3 overflow-y-auto p-6 sm:h-auto sm:overflow-y-visible">
                    <div className="space-y-3 sm:flex sm:space-x-5 sm:space-y-0">
                      <div className="grow">
                        <ModalInputField
                          labelName="Driver Name"
                          type="text"
                          placeholder="Enter User Name"
                          inputvalue={editDriver?.name}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "name",
                                value: e.target.value,
                              }),
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                      <div className="grow">
                        <ModalInputField
                          labelName="Car Plate Number"
                          type="text"
                          placeholder="Enter car plate number"
                          inputvalue={editDriver?.carPlateNo}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "carPlateNo",
                                value: e.target.value,
                              }),
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                    </div>
                    <div className="space-y-3 sm:flex sm:space-x-5 sm:space-y-0">
                      <div className="grow">
                        <ModalInputField
                          labelName="Car License Number"
                          type="text"
                          placeholder="Enter car license number"
                          inputvalue={editDriver?.carLicenseNo}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "carLicenseNo",
                                value: e.target.value,
                              }),
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                      <div className="grow">
                        <ModalInputField
                          labelName="Driver Email"
                          type="email"
                          placeholder="Enter driver email"
                          inputvalue={editDriver?.email}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "email",
                                value: e.target.value,
                              }),
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                    </div>
                    <div className="relative z-20 space-y-3 sm:flex sm:space-x-5 sm:space-y-0">
                      <div className="relative grow">
                        <div>
                          <ModalInputField
                            labelName="Country Code"
                            type="text"
                            placeholder="Enter country code"
                            inputvalue={editDriver?.countryCode}
                            // onChange={(e) => {
                            //   dispatch(
                            //     setEditDriverValue({
                            //       key: "countryCode",
                            //       value: e.target.value,
                            //     })
                            //   );
                            // }}
                          />
                          <IoIosArrowDown
                            className="absolute right-3 top-9 h-6 w-6 cursor-pointer text-white"
                            onClick={() => {
                              console.log("CountryList", selectedCountry2);
                              setSelectedCountry2(!selectedCountry2);
                            }}
                          />
                        </div>
                        <div className="absolute top-[6.6rem] z-40">
                          {selectedCountry2 && (
                            <div className="absolute -left-1 bottom-14 mx-1 h-60 w-[16.7rem] translate-y-64 overflow-y-auto rounded-lg border-2 border-white/30 bg-gradient-to-br from-[#282828] to-black text-white/90 shadow-2xl scrollbar">
                              {Countrycodes?.map((country) => {
                                console.log("single country", country);
                                return (
                                  <div
                                    key={country.code}
                                    onClick={() => {
                                      dispatch(
                                        setEditDriverValue({
                                          key: "countryCode",
                                          value: country.dial_code,
                                        }),
                                      );
                                      setSelectedCountry2(false);
                                    }}
                                    className="mx-2 my-2 flex cursor-pointer space-x-3 rounded-md px-3 py-2 text-[15px] hover:bg-white/20 hover:text-white/70"
                                  >
                                    <div>{country.name}</div>
                                    <div>{country.dial_code}</div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="grow">
                        <ModalInputField
                          labelName="Contact Number"
                          type="text"
                          placeholder="Enter Contact Number"
                          inputvalue={editDriver?.contactNumber}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "contactNumber",
                                value: e.target.value,
                              }),
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                    </div>
                    <div className="relative">
                      <ModalInputField
                        required
                        labelName="Password "
                        type={`${isVisible ? "text" : "password"}`}
                        inputvalue={editDriver.password}
                        placeholder="Set password for driver"
                        value={editDriver.password}
                        // fontawesomeIcon={faKey}
                        onChange={(e) => {
                          dispatch(
                            setEditDriverValue({
                              key: "password",
                              value: e.target.value,
                            }),
                          );
                        }}
                      />

                      <div className={`text-sm text-gray-400`}>
                        <p>
                          Password must be at least 8 characters
                          <span className="text-red-500"> *</span>
                        </p>
                        <div className={`grid grid-cols-1 p-2 sm:grid-cols-2`}>
                          <div className="flex flex-row gap-2">
                            <div className="flex items-center justify-center">
                              {/[a-z]/.test(editDriver.password) ? (
                                <Tick />
                              ) : (
                                <div className="size-2.5 rounded-full bg-gray-400" />
                              )}
                            </div>
                            One lowercase character
                          </div>
                          <div className="flex flex-row gap-2">
                            <div className="flex items-center justify-center">
                              {/[A-Z]/.test(editDriver.password) ? (
                                <Tick />
                              ) : (
                                <div className="size-2.5 rounded-full bg-gray-400" />
                              )}
                            </div>
                            One uppercase character
                          </div>
                          <div className="flex flex-row gap-2">
                            <div className="flex items-center justify-center">
                              {/[1-9]/.test(editDriver.password) ? (
                                <Tick />
                              ) : (
                                <div className="size-2.5 rounded-full bg-gray-400" />
                              )}
                            </div>
                            One digit
                          </div>
                          <div className="flex flex-row gap-2">
                            <div className="flex items-center justify-center">
                              {/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                                editDriver.password,
                              ) ? (
                                <Tick />
                              ) : (
                                <div className="size-2.5 rounded-full bg-gray-400" />
                              )}
                            </div>
                            One special symbol
                          </div>
                        </div>
                      </div>

                      <div className="absolute right-3 top-9 text-white">
                        <div
                          className="cursor-pointer text-slate-500"
                          onClick={() => {
                            setisVisible(!isVisible);
                          }}
                        >
                          {isVisible ? (
                            <FontAwesomeIcon icon={faEye} />
                          ) : (
                            <FontAwesomeIcon icon={faEyeSlash} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/*footer*/}
            <div
              className="flex items-center justify-center space-x-6 rounded-b border-slate-700 pb-6 pt-2"
              onClick={() => {
                setSelectedCountry2(false);
                setSelectedCountry1(false);
              }}
            >
              <button
                className="h-12 w-28 rounded-md border-2 border-[#1d2430] bg-[#181E29] text-lg font-medium text-gray-100 hover:bg-[#161a22] sm:w-36"
                type="button"
                onClick={cancelOnClick}
              >
                Cancel
              </button>
              <button
                disabled={emptyField || emptyFieldEdit}
                className={`h-12 w-28 rounded-md border-2 border-[#144EE3] bg-[#144EE3] text-lg font-medium text-white disabled:border-gray-600 disabled:bg-gray-600 hover:bg-[#0a44d9] sm:w-36 ${
                  emptyField || emptyFieldEdit ? "cursor-no-drop" : ""
                } `}
                type="button"
                onClick={submitOnClick}
              >
                {label}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;

export const ModalInputField = ({
  labelName,
  type,
  placeholder,
  onChange,
  fontawesomeIcon,
  inputvalue,
  inputvaluetextArea,
  onClick,
  onFocus,
  maxLength,
  required,
  onBlur,
  disabled,
}) => {
  // const [show, setShow] = useState(false);
  // const handleBlur = (inputvalue) => {
  //   if (inputvalue.trim() === "") {
  //     setShow(true);
  //   } else {
  //     setShow(false);
  //   }
  // };

  return (
    <div className="">
      <div className="space-y-1 text-left">
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon
            // icon={fontawesomeIcon}
            className="h-4 w-4 text-gray-500"
          />
          <div className="text-sm font-medium text-slate-300">
            {labelName}
            <span className={required ? "text-red-500" : "hidden"}>*</span>
          </div>
        </div>
        {type === "textarea" ? (
          <textarea
            required={required}
            className="w-full rounded-lg border px-3 py-2 text-base text-gray-700 placeholder-gray-400 focus:outline-none"
            rows="2"
            placeholder={placeholder}
            onChange={onChange}
            value={inputvaluetextArea}
            onBlur={onBlur}
          />
        ) : (
          <input
            required={required}
            type={type}
            placeholder={placeholder}
            className="w-full grow rounded-md border border-white/40 bg-black px-3 py-3.5 text-sm text-neutral-200 focus:border-blue-600 focus:outline-none"
            onChange={onChange}
            value={inputvalue}
            onClick={onClick}
            onFocus={onFocus}
            maxLength={maxLength}
            onBlur={onBlur}
            disabled={disabled}
            autoComplete="off"
            autoCorrect="off"
          />
        )}
        {/* {type === "email" &&
          inputvalue.length > 0 &&
          !checkEmail(inputvalue) && (
            <p className="text-red-400 text-sm">Not Valid Email</p>
          )}
        {show && required && (
          <p className="text-red-400 text-sm">This Field is required</p>
        )} */}
      </div>
    </div>
  );
};

const Tick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 12 12"
      fill="none"
    >
      <circle cx="6" cy="6" r="5.5" fill="#144EE3" stroke="#002EA6" />
      <path
        d="M3 6.09524L4.81818 8L9 4"
        stroke="white"
        stroke-linecap="round"
      />
    </svg>
  );
};
